export default {"src":"/_next/static/media/2.41cdb9a1.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};